import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import clsx from 'clsx';
import AuthContext from '../context/AuthContext';

function Sidebar() {
  const location = useLocation();
  // Get the hasPermission function from our context
  const { hasPermission } = useContext(AuthContext);

  // Each item now has a 'permission' key instead of 'roles'
  const navItems = [
    { href: '/dashboard', label: 'Dashboard', icon: 'dashboard', permission: 'view-juvenile' },
    { href: '/juveniles', label: 'Juvenile Roster', icon: 'roster', permission: 'view-juvenile' },
    { href: '/reports', label: 'Reports', icon: 'reports', permission: 'view-reports' },
    { href: '/audit-logs', label: 'Audit Log', icon: 'audit', permission: 'view-audit-log' },
    { href: '/admin/users', label: 'User Management', icon: 'users', permission: 'manage-users' }
  ];

  // The filter now uses the hasPermission function correctly
  const accessibleNavItems = navItems.filter(item => hasPermission(item.permission));

  const icons = {
    dashboard: <svg className="h-5 w-5 mr-3" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="7" height="7" x="3" y="3" rx="1"/><rect width="7" height="7" x="14" y="3" rx="1"/><rect width="7" height="7" x="14" y="14" rx="1"/><rect width="7" height="7" x="3" y="14" rx="1"/></svg>,
    roster: <svg className="h-5 w-5 mr-3" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="18" height="18" x="3" y="4" rx="2" ry="2"/><line x1="16" x2="16" y1="2" y2="6"/><line x1="8" x2="8" y1="2" y2="6"/><line x1="3" x2="21" y1="10" y2="10"/></svg>,
    reports: <svg className="h-5 w-5 mr-3" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" x2="12" y1="20" y2="10"/><line x1="18" x2="18" y1="20" y2="4"/><line x1="6" x2="6" y1="20" y2="16"/></svg>,
    audit: <svg className="h-5 w-5 mr-3" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>,
    users: <svg className="h-5 w-5 mr-3" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
  };

  return (
    <aside className="bg-sidebar-bg w-64 flex-shrink-0 text-sidebar-text flex flex-col">
      <div className="h-20 flex items-center px-6 border-b border-slate-700">
        <svg className="h-8 w-8 text-gold" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 3v18h18"/><path d="M7 16v-4h4v4h-4z"/><path d="M15 16v-8h4v8h-4z"/><path d="M11 16v-6h4v6h-4z"/></svg>
        <h1 className="text-xl font-bold ml-3 text-slate-100">JJMIS</h1>
      </div>
      <nav className="flex-1 overflow-y-auto p-4">
        <ul>
          {accessibleNavItems.map(item => (
            <li key={item.href}>
              <Link
                to={item.href}
                className={clsx(
                  "flex items-center p-3 rounded-lg hover:bg-slate-700",
                  { 'bg-sidebar-active text-white': location.pathname.startsWith(item.href) }
                )}
              >
                {icons[item.icon]} {item.label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  );
}

export default Sidebar;